export default {
  studentId: {
    action: false,
    payload: null
  }
};
